import { Component, OnInit, Inject, Output, EventEmitter, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ToxicGas } from '../toxic-gas';
import { ToxicGasService } from '../toxic-gas.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { PrivilegeEnum } from 'src/app/common/enumerations/privilege-enum';
// import { ToxicGas } from 'src/app/_interface/ToxicGas';
// import { ToxicGasService } from 'src/app/Services/ToxicGas/toxic-gas.service';

@Component({
  selector: 'app-toxic-gas-archive',
  templateUrl: './toxic-gase-archive.component.html',
  styleUrls: ['./toxic-gase-archive.component.scss']
})
export class ToxicGasArchiveComponent extends BaseComponent implements OnInit {
  @Output() copyItemEvent = new EventEmitter<ToxicGas>();

  archives: ToxicGas[] = [];
  filtered: ToxicGas[] = [];


  //Filters
  Month!: number;
  Year!: number;
  Filter!: string;

  constructor(
    public modal: MatDialogRef<ToxicGasArchiveComponent>,
    public service: ToxicGasService,
    protected override injector: Injector
  ) {
    super(injector);
  }

  copy(item: ToxicGas) {
    this.modal.close();
    this.copyItemEvent.emit(item);
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    if (event.target.name == "Month") {
      const currentMonth = this.Month ? this.Month.toString() : "0"
      const testMonth = Number(currentMonth + event.key);
      if (testMonth > 12)
        return false;
    } else if (event.target.name == "Year") {
      const currentYear = this.Year ? this.Year.toString() : "0"
      const testYear = Number(currentYear + event.key);
      if (testYear > (new Date()).getFullYear())
        return false;
    }

    return true;
  }

  filterHistory() {
    let query: ToxicGas[] = this.archives;
    if (!isNaN(this.Month) && this.Month) {
      const searchMonth = this.Month - 1;
      query = query.filter(item =>
        (new Date(item.createdOn).getMonth() == searchMonth) ||
        (new Date(item.updatedOn).getMonth() == searchMonth) ||
        (new Date(item.date).getMonth() == searchMonth));
    }

    if (!isNaN(this.Year) && this.Year) {
      query = query.filter(item =>
        (new Date(item.createdOn).getFullYear() == this.Year) ||
        (new Date(item.updatedOn).getFullYear() == this.Year) ||
        (new Date(item.date).getFullYear() == this.Year));
    }

    if (this.Filter && this.Filter != "") {
      const searchTerm = this.Filter.toLowerCase();
      query = query.filter(item =>
        item.name.toLowerCase().includes(searchTerm) ||
        item.description.toLowerCase().includes(searchTerm) ||
        item.createdByUser?.toLowerCase().includes(searchTerm) ||
        item.updatedByUser?.toLowerCase().includes(searchTerm) ||
        item.responsibleParty?.toLowerCase().includes(searchTerm));
    }

    this.filtered = query;
  }

  ngOnInit() {
    const self = this;
    this.service.getArchive().subscribe({
      next(data: ToxicGas[]) {
        self.archives = self.service.loadArchives(data);
        self.filterHistory();
      },
      error(msg) {
        console.log(msg);
      }
    });
  }
}
